import React from "react";

// import { css } from "@emotion/core";


import { CSSProperties } from "react";

type BtnProps = {
  value: string;
  hover?: boolean;
  type?: any;
  color?: boolean;
  size?: string;
  onClick?: any;
  disabled?: boolean;
  outline?: boolean;
  showLoader?: boolean;
  isLoading?: boolean;
  style?: CSSProperties;
};
const AppButton = (props: BtnProps) => {
  return (
    <button
      onClick={props.onClick}
      type={props.type}
      style={props.style}
      disabled={props.disabled}
      // className={`btn btn-primary d-flex align-items-center justify-content-center ${props.extraClass}`}
      className={`btn mb-2 w-100 d-flex align-items-center justify-content-center ${
        props.color ? " btn-white text-primary" : "btn-primary "
      } ${props.outline ? "btn-outline-primary" : ""} ${
        props.size ? props.size : ""
      }`}
    >
      <span>{props.value}</span>
      {/* {props.showLoader && (
        <PuffLoader
          color="white"
          size={23}
          loading={props.isLoading}
          css={css`
            margin: 0 8px;
          `}
        />
      )} */}
    </button>
  );
};

export default AppButton;
